module.exports = __webpack_public_path__ + "82ae5deede39487134a551003447c6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Source/baikal.png
// module id = 406
// module chunks = 0